export default {"src":"/_next/static/media/ic-message.d7219f0d.svg","height":800,"width":800};